import {BookmarkBorderedIcon, WarningIcon} from '@genestack/ui';
import React from 'react';

import {EyeIcon} from '../../../../../components/icons/eye-icon';
import {useUserEditingPermissions} from '../../../../../hooks/user/use-has-permission';
import {TooltipOptions, wrapWithTooltip} from '../../../../../components/tooltip/wrap-with-tooltip';

interface Props {
    displayFavoriteState: boolean;
    docInfo?: ViewModeDoc;
}

const tooltipOptions: TooltipOptions = {
    portalContainer: document.body
};

export function DocumentMeta({displayFavoriteState, docInfo}: Props) {
    const {editingPermitted} = useUserEditingPermissions();

    if (!docInfo) {
        return null;
    }

    const {readOnly, userFavorite, validationStatus} = docInfo;
    const hasMeta =
        readOnly || (displayFavoriteState && userFavorite) || validationStatus === 'INVALID';

    if (!hasMeta) {
        return null;
    }

    return (
        <React.Fragment>
            {readOnly &&
                editingPermitted &&
                wrapWithTooltip(<EyeIcon />, 'Read-only', tooltipOptions)}

            {validationStatus === 'INVALID' &&
                wrapWithTooltip(<WarningIcon />, 'Invalid', tooltipOptions)}

            {displayFavoriteState &&
                userFavorite &&
                wrapWithTooltip(<BookmarkBorderedIcon />, 'In my bookmarks', tooltipOptions)}
        </React.Fragment>
    );
}
